import React, { useState, useEffect, useRef } from 'react';
import { Card, Button, List, Col, Icon, Tooltip } from 'antd';
import { withTranslation } from 'react-i18next';
import {
  convertBounds,
  updateParams,
  getDatesRange,
  getBounds
} from "../services/display";
import queryString from "query-string";
import moment from "moment";
import logoAI from "../images/ICONO-ESTRELLAS-IA-blanco.png";
import Colors from "../themes/Colors";
import { getDomain } from "../services/utils";

const domain = getDomain(window.location.hostname);
const isLatinAd = domain === 'latinad';


const getBillingCountry = (currency, countries) => {
  let selectedCountry = null;
  let newCurrency = currency;

  // a) Find by default_currency.code
  selectedCountry = countries.find(c => c.default_currency && c.default_currency.code === currency);

  // b) If not found, find by currencies array
  if (!selectedCountry) {
    selectedCountry = countries.find(c => c.currencies && c.currencies.some(curr => curr.code === currency));
  }

  // c) If currency is USD or no country was found, use International Invoice
  if (currency === 'USD' || !selectedCountry) {
    newCurrency = 'USD';
    selectedCountry = countries.find(c => c.alpha_2_code === 'F');
  }

  if (!selectedCountry) {
    return {
      currency: 'USD',
      name: 'Factura Internacional',
      alpha_2_code: 'F'
    };
  }

  return {
    currency: newCurrency,
    name: selectedCountry.name,
    alpha_2_code: selectedCountry.alpha_2_code
  };
}

const CampaignProposals = ({ 
  proposals, 
  t, 
  cart,
  countries,
  history,
  setCampaignName,
  setCampaignDescription,
  setCategoriesId,
  setBilling,
  removeDisplaysCart,
  setSelectedProposalId,
  openChatbotWithGreeting,
  currency,
  start_date,
  end_date,
  campaignZonesLatLng,
  showAllDisplays,
}) => {
  const isInitialMount = useRef(true);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    if (!selectedItem) {
        return;
    }

    if (selectedItem && cart && cart.length === 0) {
      isInitialMount.current = false;
    }

    if (selectedItem && !isInitialMount.current) {    
      const billingCountry = getBillingCountry(currency, countries);

      setCampaignName(selectedItem.campaign_name)
      setCampaignDescription(selectedItem.objectives)
      setCategoriesId(selectedItem.campaign_category)
      setBilling(
        billingCountry.currency,
        billingCountry.name,
        billingCountry.alpha_2_code
      )
      const bounds = getBounds(campaignZonesLatLng);

      let displays = selectedItem.displays.join(',').toString();
      if (openChatbotWithGreeting) openChatbotWithGreeting(t('ChatbotPlannerGreeting'));
      history.push(
        "/map?" +
        queryString.stringify(
          updateParams(
            {},
            {
              ...getDatesRange(
                start_date,
                end_date
              ),
              displays_list: displays,
              lat_ne: bounds.lat_ne,
              lat_sw: bounds.lat_sw,
              lng_ne: bounds.lng_ne,
              lng_sw: bounds.lng_sw,
              show_all_displays: showAllDisplays ? '1' : '0',
            },
            { arrayFormat: "bracket" }
          )
        )
      );
      setSelectedItem(null);
    }
    }, [cart, selectedItem]);

  return (
    <div style={{ padding: '0px 15px' }}>
      <List style={{display: proposals.length <= 0 ? 'none' : ''}}
        grid={{ gutter: 24, column: 1 }}
        dataSource={proposals}
        renderItem={(item, index) => {
          const failed = item.status && item.status !== 'ok';

          return (
          <Col xs={24} sm={24} md={12} lg={6} xl={6} style={{padding: '0'}} className='listItemAI'>
            <List.Item>
              <Card
                title={
                  <Tooltip title={item.campaign_name}>
                    <div style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        color: isLatinAd ? 'white' : Colors.coal,
                        textAlign: 'center',
                        fontSize: 'large',
                        fontWeight: '600'
                    }}>
                      {t('Proposal')} {index + 1} <img src={logoAI} style={{maxHeight: "35px"}} alt=""/> <hr style={{display: 'block', height: '1px', border: '0', borderTop: '1px solid', borderColor: Colors.primaryAccent, margin: '1em 0 0', padding: '0'}}></hr>
                      <span className='cardSubtitleAI' style={{fontSize: '13px'}}>
                        {item.campaign_name}
                      </span>
                    </div>
                  </Tooltip>
                }
                actions={failed ? [] : [
                  <Button type="primary" className='btnAI btnPropsAI' onClick={() => {
                    if (cart) removeDisplaysCart()
                    setSelectedProposalId(index);
                    setSelectedItem(item);
                  }}>{t('Select')}</Button>,
                ]}
                style={{
                      minHeight: '350px',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      background: isLatinAd ? 'black' : Colors.background,
                      color: isLatinAd ? 'white' : Colors.coal
                }}
                className='cardShadow'
              >
                {failed ? (
                  <div className='proposalObj cardShadow' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: '10px', padding: '20px 10px' }}>
                    <Icon type="exclamation-circle" theme="outlined" style={{ fontSize: '28px', color: Colors.error || '#f5222d' }} />
                    <p style={{ margin: 0 }}>{t('This proposal could not be generated')}</p>
                    {item.detail && (
                      <p style={{ margin: 0, fontSize: 'smaller', opacity: 0.8 }}>{item.detail}</p>
                    )}
                  </div>
                ) : (
                <div>
                  <div className='proposalImg cardShadow' style={{backgroundImage: `url(${item.image_url})`}}>
                  </div>
                  <div className='proposalObj cardShadow'>
                    <p><Icon type="check-circle" /> {t('Strategy')}</p>
                    <Tooltip title={item.justification}>
                      <p className='proposalObjs'>{item.objectives}</p>
                    </Tooltip>
                    <p style={{margin: 0, fontSize: 'smaller', height: '35px'}}><Icon type="user" style={{ marginRight: "5px" }}/>{t('Segmentation') + ' > ' + t(item.segmentation_type)}</p>
                  </div>
                  <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '10px', fontSize: 'x-small'}} className='proposalInfo'>
                    <p style={{display: 'flex', alignItems: 'center', marginRight: '10px'}}>
                      <Tooltip title={
                        Object.keys(item.screen_type_counts || {}).map((key) => {
                          const formattedKey = key.charAt(0).toUpperCase() + key.slice(1);
                          const count = item.screen_type_counts[key];

                          return (
                              <div key={key}>
                                  {formattedKey}: {count}
                              </div>
                          );
                        })
                      }>
                        <Icon
                          style={{ fontSize: "16px", margin: '5px 0px'}}
                          type="desktop"
                          theme="outlined"
                        />
                        {item.displays.length}
                      </Tooltip>
                    </p>
                    <p style={{display: 'flex', alignItems: 'center', marginRight: '10px'}}>
                      <Tooltip title={t('Men')}>
                        <Icon
                          style={{ fontSize: "16px", margin: '5px 0px'}}
                          type="man"
                          theme="outlined"
                        />
                        {item.demographics.male_percentage} %
                      </Tooltip>
                    </p>
                    <p style={{display: 'flex', alignItems: 'center', marginRight: '10px'}}>
                      <Tooltip title={t('Women')}>
                        <Icon
                          style={{ fontSize: "16px", margin: '5px 0px'}}
                          type="woman"
                          theme="outlined"
                        />
                        {item.demographics.female_percentage} %
                      </Tooltip>
                    </p>
                    <p style={{display: 'flex', alignItems: 'center'}}>
                      <Tooltip title={t('Ages')}>
                        <Icon
                          style={{ fontSize: "16px", margin: '5px 0px'}}
                          type="user"
                          theme="outlined"
                        />
                        {item.demographics.age_lower_bound} - {item.demographics.age_upper_bound} {' ' + t('years')}
                      </Tooltip>
                    </p>
                  </div>
                </div>
                )}
              </Card>
            </List.Item>
          </Col>
          );
        }}
      />
      <span style={{display: proposals.length > 0 ? 'none' : ''}}>
        {t('Error')} {t('Creating proposals') }
      </span>
    </div>
  );
};

export default withTranslation()(CampaignProposals);